var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPalmIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 28,
    viewBox: "0 0 21 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 28,
    fill: "url(#pattern0_2601_33)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_2601_33",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_2601_33",
    transform: "scale(0.047619 0.0357143)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_2601_33",
    width: 21,
    height: 28,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAAcCAYAAACOGPReAAAACXBIWXMAAAsTAAALEwEAmpwYAAAB2klEQVRIibWTu2tUQRSHv90EDWElW2iCokZFEGuxtwyiaCwsrCxsbRYEK0lhYSUiFlaC4j8g2ATxARbio0qhoILPQhQk0RDBQD6LPdcdx3vNXdz8YJid8/j2nnNmUMnWGbv6qM6o60tiTqhz6op6W22m/jy4WBfs6aE6FvaGeinx3Ut8q0JRz2fgpnouA46W5f4LitpRl9T36ib1R5R8s6ItqAzT03bgGLANGAK+AU+AXcARYB/wATge/g4wEbmfgbvAY+D3l55Wly3XI3Vc3a9uUa9WxBkVrGuoO4GLQIO/9QV4CcwBs8Ae4DCwFZisyLk2DLwBpkucGwOwG/gZtkVgA/AKuAK8LsmrHFRHXYySnsaUH6iT6uWwr6jX1Vad6Z9NevRWnQi76gF1SL2VxNyxe38roeN2r43qvLo38alOxe9R9VkCnk45zawbU8AIsBx9fhH2duwjsS8Bh4B3cT6aQnLo5thPAfdLh9DTJ+AgsJDklUK/AzPAjcxePJJWZn9O98F8/cOa9XQsb3qsHdG7kxW3pZ2eh7N/Xlil5CrNp4e8/CoVA2rXCe4XWkt1oYXydv0XtJXtA4HW+sJ+oYVq9bYutL0W0L7Ub08HOqgCNtAr1ZfW5Jn+Aqt/mQ9xEbz5AAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPalmIcon);
export default __webpack_public_path__ + "static/media/palm-icon.feab0ea09863e2d742ca6bb1790c0af1.svg";
export { ForwardRef as ReactComponent };